import React from "react";
import Design from "./Design";
function Couch({ size, chairs, chairSize, borderColor = "#F8B34B" }) {
  return (
    <>
      <div className="flex flex-wrap items-center bg-white shadow-lg mx-1">
        <Design
          size={size}
          chairs={chairs}
          chairSize={chairSize}
          borderColor={borderColor}
        />
        <Design
          size={size}
          chairs={chairs}
          chairSize={chairSize}
          borderColor={borderColor}
        />
        <Design
          size={size}
          chairs={chairs}
          chairSize={chairSize}
          borderColor={borderColor}
        />
      </div>
    </>
  );
}

export default Couch;
